// Свежий серверный блок для фонового коммита загрузки. Сначала кеш урока (пока
// урок открыт или только что закрыт, он актуален: запись блока инвалидирует
// список), а если записи или блока в ней нет — запрос. Ролик грузится минутами, и за это
// время автор успевает уйти в другой урок: неподписанный список RTK выбрасывает,
// и без запроса долгая загрузка всегда упиралась бы в «блока уже нет».
import type { AppDispatch, RootState } from '@/store'
import { lessonsApi } from '@/features/editor/lessonsApi'
import type { Block } from '@/types/blocks'

export const readFreshBlock = async (
  getState: () => RootState,
  dispatch: AppDispatch,
  lessonId: number,
  blockId: number,
): Promise<Block | undefined> => {
  const cached = lessonsApi.endpoints.getLessonBlocks.select(lessonId)(getState()).data
  const hit = cached?.find((b) => b.id === blockId)
  if (hit) return hit
  // Подписка держится до ответа: `unwrap()` читает данные из КЕША уже после
  // запроса, а отложенная инвалидация выкинула бы неподписанную запись (тот же
  // приём, что `loadBlocks` в `readSourceBlockPairs.ts`).
  // Кеш без блока мог отстать (блок только что создан, источник сменился), поэтому
  // «блока нет» отвечает только сервер: иначе готовый ролик оставался без блока.
  const req = dispatch(
    lessonsApi.endpoints.getLessonBlocks.initiate(lessonId, { forceRefetch: Boolean(cached) }),
  )
  try {
    const blocks = await req.unwrap()
    return blocks.find((b) => b.id === blockId)
  } catch {
    return undefined
  } finally {
    req.unsubscribe()
  }
}
